import type { ComponentProps, ReactNode } from "react"
import { MenuItem } from "@mui/material"
import type { ModelSelectorListOption } from "./types"

export interface ModelSelectorOptionProps {
  option: ModelSelectorListOption
  label?: ReactNode
}

export function ModelSelectorOption({
  option,
  label,
  ...menuItemProps
}: ModelSelectorOptionProps & ComponentProps<typeof MenuItem>) {
  return (
    <MenuItem value={option.id} {...menuItemProps}>
      <span className="model-selector-option-label" role="option">
        {label ?? option.name}
      </span>
    </MenuItem>
  )
}
